// Logotipo corporativo original de ATENTO (subido por la titular).
// mix-blend-multiply funde el fondo blanco del archivo con el fondo marfil de la web.
export const LogoMark = ({ className = "w-10 h-10" }) => (
  <img
    src="/uploads/logo-atento.png"
    alt=""
    aria-hidden="true"
    data-testid="logo-mark"
    className={`${className} object-contain`}
  />
);

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <LogoMark className="w-9 h-9 text-atento-blue shrink-0" />
    <div className="leading-none">
      <span className="block font-accent font-bold text-lg tracking-[0.14em] text-atento-blue">
        ATENTO
      </span>
      <span className="block text-[10px] font-accent font-medium uppercase tracking-[0.18em] text-sage-dark mt-1">
        Gabinete de Psicopedagogía
      </span>
    </div>
  </div>
);
